// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.media-container {\n    height: 800px; \n    width: 400px;\n    white-space: nowrap;\n    text-align: center; margin: 0;\n}\n\n", ""]);
// Exports
module.exports = exports;
